import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Country = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.countryList);
	return (
		<>
			<FilterName type="COUNTRY" />
			<Checkbox data={data} type="COUNTRY" handleSearch={handleSearch} nextFilterLevel={3} />
		</>
	);
};

export default Country;
